/**
 * 图标分类与中文说明（与 registry.json CDN 列表对齐）。
 * 新增 symbol 后：归入合适分类，或暂时放入「其他图标」；运行 node scripts/build-categories.js 校验。
 */
export const iconCategories = [
  {
    name: '图层操作类',
    nameEn: 'Layer Operations',
    icons: [
      { name: 'a-AllLayersVisible', desc: '图层全部可见' },
      { name: 'a-AllLayersHidden', desc: '图层全部隐藏' },
      { name: 'a-KeepSelected', desc: '保留选定' },
      { name: 'a-RestoreLayers', desc: '恢复图层' },
      { name: 'a-SelectedHidden', desc: '选定隐藏' },
      { name: 'layer', desc: '图层' },
    ],
  },
  {
    name: '模型与对齐类',
    nameEn: 'Model & Alignment',
    icons: [
      { name: 'a-ModelAlignment', desc: '模型对齐' },
      { name: 'a-ModelAlignment_gray', desc: '模型对齐(灰)' },
      { name: 'a-Model-ImageAlignment', desc: '图模对齐' },
      { name: 'Model', desc: '模型' },
      { name: 'Align', desc: '对齐' },
      { name: 'Align_left', desc: '左对齐' },
      { name: 'Align_center', desc: '居中对齐' },
      { name: 'Align_right', desc: '右对齐' },
      { name: 'Centre', desc: '居中' },
    ],
  },
  {
    name: '分割与合并类',
    nameEn: 'Split & Merge',
    icons: [
      { name: 'a-ManualSegmentation', desc: '手动分割' },
      { name: 'a-AutoSegmentation', desc: '自动分割' },
      { name: 'a-zujian548', desc: '合并' },
      { name: 'a-zujian549', desc: '拆分' },
      { name: 'a-zujian551', desc: '组件551' },
      { name: 'a-zujian552', desc: '组件552' },
      { name: 'a-zujian553', desc: '组件553' },
      { name: 'a-zujian554', desc: '组件554' },
      { name: 'Split', desc: '分割' },
      { name: 'Merger', desc: '合并' },
    ],
  },
  {
    name: '视图与显示类',
    nameEn: 'View & Display',
    icons: [
      { name: 'Eye_open', desc: '显示' },
      { name: 'Eye_close', desc: '隐藏' },
      { name: 'Eye_24', desc: '眼睛(24px)' },
      { name: 'Eye_No_24', desc: '不可见(24px)' },
      { name: 'Eye_close_24', desc: '关闭眼睛(24px)' },
      { name: 'Eye_No', desc: '不可见' },
      { name: 'Fullscr', desc: '全屏' },
      { name: 'a-Exitfullscreen', desc: '退出全屏' },
      { name: 'Newscreen', desc: '新窗口' },
      { name: 'Fold', desc: '折叠' },
      { name: 'Unfold', desc: '展开' },
      { name: 'Fold_V', desc: '垂直折叠' },
      { name: 'Unfold_V', desc: '垂直展开' },
      { name: 'Camera_24', desc: '监控摄像头(24px)' },
      { name: 'Camera2', desc: '监控样式(勿用于添加照片)' },
      { name: 'camera2', desc: '照相机线框/添加照片' },
    ],
  },
  {
    name: '方向与箭头类',
    nameEn: 'Direction & Arrows',
    icons: [
      { name: 'Arrow_Up', desc: '向上箭头' },
      { name: 'Arrow_down', desc: '向下箭头' },
      { name: 'Arrow_left', desc: '向左箭头' },
      { name: 'Arrow_right', desc: '向右箭头' },
      { name: 'Up', desc: '上' },
      { name: 'Down', desc: '下' },
      { name: 'Left', desc: '左' },
      { name: 'Right', desc: '右' },
      { name: 'Put_up_24', desc: '上移(24px)' },
      { name: 'Put_down_24', desc: '下移(24px)' },
      { name: 'Put_left_24', desc: '左移(24px)' },
      { name: 'Put_right_24', desc: '右移(24px)' },
    ],
  },
  {
    name: '编辑操作类',
    nameEn: 'Edit Operations',
    icons: [
      { name: 'Edit', desc: '编辑' },
      { name: 'Edit_24', desc: '编辑(24px)' },
      { name: 'Add', desc: '添加' },
      { name: 'Addfld', desc: '添加字段' },
      { name: 'aadd', desc: '添加' },
      { name: 'Plus', desc: '加号' },
      { name: 'Plus_re', desc: '加号(矩形)' },
      { name: 'Fangjia', desc: '方加（树表展开+）' },
      { name: 'Fangjian', desc: '方减（树表收起−）' },
      { name: 'Subtract', desc: '减少' },
      { name: 'Del', desc: '删除' },
      { name: 'Clear', desc: '清除' },
      { name: 'Duplicate', desc: '复制' },
      { name: 'Undo', desc: '撤销' },
      { name: 'Redo', desc: '重做' },
      { name: 'Refresh', desc: '刷新' },
      { name: 'Refresh_24', desc: '刷新(24px)' },
      { name: 'a-Refresh1', desc: '刷新1' },
      { name: 'Rewrite', desc: '重写' },
      { name: 'Move', desc: '移动（旧）' },
      { name: 'move', desc: '移动' },
      { name: 'Grab', desc: '抓取' },
      { name: 'Repair', desc: '修复' },
    ],
  },
  {
    name: '文件与文档类',
    nameEn: 'File & Document',
    icons: [
      { name: 'File', desc: '文件' },
      { name: 'FilePosition', desc: '文件定位' },
      { name: 'FileComparison', desc: '文件对比（表内/弹窗彩色操作图标用 xl · 24px）' },
      { name: 'FileVersion', desc: '文件版本（表内彩色操作图标用 xl · 24px）' },
      { name: 'filede', desc: '文件详情' },
      { name: 'Folder', desc: '文件夹' },
      { name: 'Import', desc: '导入' },
      { name: 'Import_G', desc: '导入(绿)' },
      { name: 'Download', desc: '下载' },
      { name: 'Upload1', desc: '上传1' },
      { name: 'Upload2', desc: '上传2' },
      { name: 'save', desc: '保存' },
      { name: 'Print', desc: '打印' },
      { name: 'book', desc: '书本' },
    ],
  },
  {
    name: '清单与审核类',
    nameEn: 'Checklist & Review',
    icons: [
      { name: 'CheckFile', desc: '文件审核' },
      { name: 'Checklist', desc: '清单' },
    ],
  },
  {
    name: '状态与提示类',
    nameEn: 'Status & Tips',
    icons: [
      { name: 'Check', desc: '勾选' },
      { name: 'Check_cir', desc: '勾选(圆)' },
      { name: 'Check_re', desc: '勾选(矩形)' },
      { name: 'Wrong', desc: '错误' },
      { name: 'Wrong_cir', desc: '错误(圆)' },
      { name: 'Close_24', desc: '关闭(24px)' },
      { name: 'Warning', desc: '警告' },
      { name: 'Warning_color', desc: '警告(彩色)' },
      { name: 'Warning_tr', desc: '警告(三角)' },
      { name: 'Question', desc: '问号' },
    ],
  },
  {
    name: '时间与日期类',
    nameEn: 'Time & Date',
    icons: [
      { name: 'Time', desc: '时间' },
      { name: 'Time_24', desc: '时间(24px)' },
      { name: 'Time_reload', desc: '时间刷新' },
      { name: 'Time_Reload_24', desc: '时间刷新(24px)' },
      { name: 'Time_Quarter_24', desc: '季度时间' },
      { name: 'Calendar', desc: '日历' },
      { name: 'clock', desc: '时钟' },
    ],
  },
  {
    name: '用户与通讯类',
    nameEn: 'User & Communication',
    icons: [
      { name: 'User', desc: '用户' },
      { name: 'User2', desc: '用户2' },
      { name: 'Auth24', desc: '权限(24px)' },
      { name: 'Mail', desc: '邮件' },
      { name: 'Phone', desc: '电话' },
      { name: 'phone2', desc: '电话2' },
      { name: 'pc', desc: '电脑' },
      { name: 'Dialog', desc: '对话' },
      { name: 'Share', desc: '分享' },
    ],
  },
  {
    name: '布局与界面类',
    nameEn: 'Layout & UI',
    icons: [
      { name: 'Layout', desc: '布局' },
      { name: 'Layout_', desc: '布局_' },
      { name: 'Layout_top', desc: '顶部布局' },
      { name: 'List', desc: '列表' },
      { name: 'List2', desc: '列表2' },
      { name: 'Category', desc: '分类' },
      { name: 'Chart_241', desc: '图表' },
      { name: 'Plan_24', desc: '计划(24px)' },
      { name: 'Plan_241', desc: '计划2' },
      { name: 'a-Todolist_24', desc: '待办列表' },
      { name: 'rongqi', desc: '容器' },
      { name: 'rongqi1', desc: '容器1' },
      { name: 'rongqi2', desc: '容器2' },
      { name: 'a-rongqi2', desc: '容器 a2' },
      { name: 'a-rongqi3', desc: '容器 a3' },
      { name: 'a-rongqi3271', desc: '容器3271' },
      { name: 'a-rongqi1851', desc: '容器1851' },
      { name: 'a-rongqi4468', desc: '容器4468' },
    ],
  },
  {
    name: '数据与图表类',
    nameEn: 'Data & Charts',
    icons: [
      { name: 'data', desc: '数据' },
      { name: 'Stock', desc: '库存' },
      { name: 'Money', desc: '金额' },
      { name: 'RMB', desc: '人民币' },
      { name: 'Num', desc: '数字' },
      { name: 'Efficient', desc: '效率' },
      { name: 'ratio', desc: '比率' },
      { name: 'BarChart24', desc: '柱状图(24px)' },
      { name: 'LineChart24', desc: '折线图(24px)' },
      { name: 'DataAnalysis24', desc: '数据分析(24px)' },
      { name: 'SalesData24', desc: '销售数据(24px)' },
    ],
  },
  {
    name: '业务指标 24px',
    nameEn: 'Business KPI (24px)',
    icons: [
      { name: 'ActualUsage24', desc: '实际用量' },
      { name: 'Consumption24', desc: '消耗量' },
      { name: 'Inventory24', desc: '库存' },
      { name: 'InventoryRate24', desc: '库存率' },
      { name: 'Factory24', desc: '工厂' },
      { name: 'IssueLog24', desc: '问题日志' },
      { name: 'other24', desc: '其他(24px)' },
      { name: 'a-Confirmeddata24', desc: '确认数据' },
      { name: 'a-Designquantity24', desc: '设计量' },
      { name: 'a-Excessconsumption24', desc: '超耗' },
      { name: 'a-Lossamount24', desc: '损耗金额' },
      { name: 'a-Mainstructure24', desc: '主体结构' },
      { name: 'a-Plannedconsumption24', desc: '计划消耗' },
      { name: 'a-Targetvalue24', desc: '目标值' },
      { name: 'a-Temporaryconstruction24', desc: '临建' },
    ],
  },
  {
    name: '混凝土与物料业务',
    nameEn: 'Concrete & Materials',
    icons: [
      { name: 'hnt', desc: '混凝土' },
      { name: 'exhnt', desc: '混凝土(扩展)' },
      { name: 'exmoney', desc: '金额(扩展)' },
      { name: 'hzj', desc: '汇总' },
      { name: 'lsd', desc: '流水单' },
      { name: 'jzcircle', desc: '浇筑圈' },
      { name: 'rightc', desc: '右侧确认' },
      { name: 'zfrecord', desc: '流转记录' },
      { name: 'a-Concretetransfer', desc: '混凝土转运' },
      { name: 'a-TransferRecords', desc: '转运记录' },
    ],
  },
  {
    name: '智能与 AI',
    nameEn: 'AI & Smart',
    icons: [
      { name: 'AI', desc: 'AI' },
      { name: 'idea', desc: '创意/想法' },
      { name: 'Smart', desc: '智能' },
    ],
  },
  {
    name: '链接与导航类',
    nameEn: 'Link & Navigation',
    icons: [
      { name: 'Link', desc: '链接（通用；关联/取消关联请用 Link2 + unlink 成对）' },
      { name: 'Link2', desc: '链接2 · 关联（与 unlink 成对，勿与 Link 混用）' },
      { name: 'unlink', desc: '取消链接 · 取消关联（与 Link2 成对，勿与 Link2 拆开另配）' },
      { name: 'ALINK', desc: '链接 ALINK' },
      { name: 'ARlink', desc: '链接 ARlink' },
      { name: 'AUlink', desc: '链接 AUlink' },
      { name: 'Slink', desc: '链接 Slink' },
      { name: 'USlink', desc: '链接 USlink' },
      { name: 'WJlink', desc: '链接 WJlink' },
      { name: 'WJunlink', desc: '取消链接 WJunlink' },
      { name: 'home', desc: '首页' },
      { name: 'Position', desc: '定位' },
      { name: 'location_24', desc: '位置(24px)' },
      { name: 'Search', desc: '搜索' },
    ],
  },
  {
    name: '筛选与排序类',
    nameEn: 'Filter & Sort',
    icons: [
      { name: 'Filter', desc: '筛选' },
      { name: 'Filter-Fill', desc: '筛选(填充)' },
      { name: 'Filt', desc: '筛选2' },
      { name: 'No_Filter', desc: '无筛选' },
      { name: 'Sort', desc: '排序' },
    ],
  },
  {
    name: '工具与设置类',
    nameEn: 'Tools & Settings',
    icons: [
      { name: 'Set', desc: '设置' },
      { name: 'Lock', desc: '锁定' },
      { name: 'Emit', desc: '发射' },
      { name: 'Play', desc: '播放' },
      { name: 'Box', desc: '盒子' },
      { name: 'Package', desc: '包裹' },
    ],
  },
  {
    name: '标记与收藏类',
    nameEn: 'Mark & Favorite',
    icons: [
      { name: 'Star', desc: '星标' },
      { name: 'Heart', desc: '心形' },
      { name: 'Tag', desc: '标签' },
      { name: 'biaoqian', desc: '标签2' },
      { name: 'Mark', desc: '标记' },
    ],
  },
  {
    name: '图片与媒体类',
    nameEn: 'Image & Media',
    icons: [
      { name: 'Pic', desc: '图片' },
      { name: 'Pic2', desc: '图片2' },
      { name: 'Dia', desc: '图表' },
    ],
  },
  {
    name: '文字格式类',
    nameEn: 'Text Format',
    icons: [
      { name: 'Bold', desc: '加粗' },
      { name: 'Italic', desc: '斜体' },
      { name: 'Underline', desc: '下划线' },
    ],
  },
  {
    name: '建筑与交通类',
    nameEn: 'Building & Transport',
    icons: [
      { name: 'Building', desc: '建筑' },
      { name: 'Bus', desc: '巴士' },
      { name: 'Plane', desc: '飞机' },
    ],
  },
  {
    name: '其他图标',
    nameEn: 'Others',
    icons: [
      { name: 'resizebottomright', desc: '调整大小' },
      { name: 'shandian', desc: '闪电' },
      { name: 'Vic', desc: '胜利' },
      { name: 'US', desc: 'US' },
      { name: 'US2', desc: 'US2' },
      { name: 'Sub_re', desc: '订阅' },
      { name: 'horizontal_ellipsis1', desc: '水平省略号' },
    ],
  },
];
